import index from "@/views";
import Designer from "@/views/engine-designer/designer/EngineDesigner";
import Finish from "@/views/engine-designer/finish/Finish";
export default [
  {
    path: "/designer",
    component: index,
    meta: {
      layout: "engine-designer",
      requiresAuth: true
    },
    children: [
      {
        path: "",
        name: "Home",
        component: ()=>import('@/views/engine-designer/home'),
      },
      {
        path: "create",
        name: "Designer",
        component: Designer,
      },
      {
        path: ":id",
        name: "Designer by id",
        component: Designer,
      },
      {
        path: ":id/finish",
        name: "Finished design",
        component: Finish,
      },
    ],
  },
];
